import { Button } from "flowbite-react";
import { AlertTriangle } from "lucide-react";

type ErrorMessageProps = {
  message: string
  onRetry?: () => void
  retryLabel?: string
};

export const ErrorMessage = ({
  message,
  onRetry,
  retryLabel = "Réessayer",
}: ErrorMessageProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <AlertTriangle className="text-error mb-4" size={56} />
      <p className="text-foreground mb-4">
        <span className="font-bold">Une erreur s'est produite</span>
        <br />
        <span className="text-sm">{message}</span>
      </p>
      {onRetry && (
        <Button
          onClick={onRetry}
          color="primary"
          size="sm"
        >
          {retryLabel}
        </Button>
      )}
    </div>
  );
};
